import { useRouter } from 'next/router';

/**
 * @deprecated This is a faulty logic. DO NOT USE
 */
function useIsSharedPage() {
  const { query } = useRouter();

  const { sharedToken } = query;

  const isSharedPage = !!sharedToken;

  return isSharedPage;
}

export default useIsSharedPage;
